import type { ReactNode } from 'react';
import { HelpBulb } from './HelpBulb';

interface CardTitleProps {
  /** ID of the `h2`, referenced by the card's `aria-labelledby`. */
  id?: string;
  /** Help URLs of the card: its screen section first, then the KPIs it shows (see HelpBulb). */
  help: readonly string[];
  children: ReactNode;
}

/** `h2.card__title` with the help bulb after it. */
export function CardTitle({ id, help, children }: CardTitleProps) {
  return (
    <div className="card__title-row">
      <h2 className="card__title" id={id}>
        {children}
      </h2>
      {id ? (
        <HelpBulb topics={help} labelledBy={id} />
      ) : (
        <HelpBulb topics={help} label={typeof children === 'string' ? children : undefined} />
      )}
    </div>
  );
}
